require('./index.css');
require('../lib/ztree/css/zTreeStyle/zTreeStyle.css');
require('../lib/ztree/js/jquery.ztree.all-3.5.min.js');

var locale = require('./i18n');

Enhancer.registerWidget({
    construct: function(profile, zContext) {
        this.prof = profile;
        this.__createTree(zContext);
    },
    __createTree: function(zContext) {
        var self = this;
        var $container = self.getContainer();
        var profile = self.prof;
        var dataConfig = profile.dataConfig || {};
        var settings = profile.settings || {};
        settings.callback = settings.callback || {};
        settings.callback.onExpand = function(event, treeId, treeNode) {
            if (treeNode.dataLoaded) {
                self.trig('onNodeExpand');
                return;
            }
            self.__fetchSubNodes(treeNode, function(nodes) {
                treeNode.dataLoaded = true;
                self.zTreeObj.addNodes(treeNode, nodes);
                self.trig('onNodeExpand');
            });
        };
        settings.callback.onClick = function(event, treeId, treeNode) {
            self.lastSelectedNode = treeNode;
            self.trig('onNodeClick');
        };
        settings.callback.onCheck = function(event, treeId, treeNode) {
            self.lastCheckedNode = treeNode;
            self.trig('onNodeCheck');
        };
        settings.callback.onRightClick = function(event, treeId, treeNode) {
            self.trig('onNodeRightClick');
            return true;
        };
        settings.callback.onDblClick = function(event, treeId, treeNode) {
            self.lastSelectedNode = treeNode;
            self.trig('onNodeDblClick');
        };
        settings.callback.noCollapse = function(event, treeId, treeNode) {
            self.trig('onNodeCollapse');
        };

        // binding first level data.
        dataConfig.subNodesBindingMethod === 'async'

            ? self.__fetchSubNodes( {
                id: dataConfig.rootValue,
                name: '__root__',
                level: 0
            }, function(nodes) {
                self.$tree = $('<ul>').attr('id', self.id() + '_tree')
                    .addClass('ztree')
                    .appendTo($container);
                self.zTreeObj = $.fn.zTree.init(
                    self.$tree,
                    profile.settings,
                    nodes
                );
                
                var firstNode = self.zTreeObj.getNodes()[0];
                self.lastSelectedNode = firstNode;
                self.trig('complete');
                if (firstNode) {
                    $('#' + firstNode.tId + '_a').click();
                }
            })

            : self.__fetchTree( function(nodes) {
                self.$tree = $('<ul>').attr('id', self.id() + '_tree')
                    .addClass('ztree')
                    .appendTo($container);
                self.zTreeObj = $.fn.zTree.init(
                    self.$tree,
                    profile.settings,
                    nodes
                );
                self.zTreeObj.expandAll(true);

                var firstNode = self.zTreeObj.getNodes()[0];
                self.lastSelectedNode = firstNode;
                self.trig('complete');
                if (firstNode) {
                    $('#' + firstNode.tId + '_a').click();
                }
            } );
    },
    __fetchTree: function(callback) {
        var dataConfig = this.prof.dataConfig;
        this.getSourceData(dataConfig.datasourceId, {}, function(result) {
            var nodes = (result || []).map(function(n) {
                isLeaf = n[dataConfig.isNodeLeafField] || '';
                isLeaf = isLeaf === 'Y'
                    || isLeaf === 1 
                    || isLeaf === '1'
                    || (isLeaf + '').toLowerCase() === 'true'
                    || (isLeaf + '').toLowerCase() === 'yes';

                return {
                    id: n[dataConfig.nodeValueField],
                    name: n[dataConfig.nodeDisplayNameField],
                    isLeaf: isLeaf,
                    isParent: !isLeaf,
                    parentId: n[dataConfig.nodeParentField],
                    ord: parseInt(n[dataConfig.nodeOrdField]) || 0,
                    children: isLeaf ? false : [],
                    dataLoaded: true,
                    data: n
                };
            });

            var root = {
                id: dataConfig.rootValue,
                isLeaf: false,
                level: 0,
                children: []
            };
            function transfer(parent, nodes) {
                var id = parent.id;
                if (parent.isLeaf) return parent;
                var n;
                for (var i = 0; i < nodes.length; i++) {
                    n = nodes[i];
                    n.level = parent.level + 1;
                    if (n.parentId == id) {
                        parent.children.push(n);
                        arguments.callee(n, nodes);
                    }
                }
                if (dataConfig.nodeOrdField) {
                    parent.children = parent.children.sort(function(a, b) {
                        return a.ord - b.ord;
                    } );
                }
                return parent;
            }

            transfer(root, nodes);
            callback(root.children);
        });
    },
    __fetchSubNodes: function(parent, callback) {
        var dataConfig = this.prof.dataConfig;
        this.getSourceData(dataConfig.datasourceId, {
                filters: {
                    groupOp: 'AND',
                    rules: [{
                        field: dataConfig.nodeParentField, 
                        op: 'eq',
                        data: parent.id
                    }]
                }
            }, function(result) {
                var nodes = (result || []).map(function(n) {
                    isLeaf = n[dataConfig.isNodeLeafField] || '';
                    isLeaf = isLeaf === 'Y'
                        || isLeaf === 1 
                        || isLeaf === '1'
                        || (isLeaf + '').toLowerCase() === 'true'
                        || (isLeaf + '').toLowerCase() === 'yes'

                    return {
                        id: n[dataConfig.nodeValueField],
                        name: n[dataConfig.nodeDisplayNameField],
                        isLeaf: isLeaf,
                        isParent: !isLeaf,
                        parentId: parent.id,
                        level: parseInt(parent.level) + 1,
                        ord: parseInt(n[dataConfig.nodeOrdField]) || 0,
                        children: isLeaf ? false : [],
                        data: n
                    };
                });
                if (dataConfig.nodeOrdField) {
                    nodes = nodes.sort(function(a, b) {
                        return a.ord - b.ord;
                    } );
                }
                callback(nodes);
            });
    },

    getData: function() {
        if (!this.zTreeObj) {
            return {};
        }
        var data = {};
        var self = this;

        if (self.lastCheckedNode) {
            var lcn = self.lastCheckedNode;
            data.LAST_CHECKED_NODE_NAME = lcn.name;
            data.LAST_CHECKED_NODE_VALUE = lcn.id;
            data.LAST_CHECKED_LEVEL = lcn.level;
            data.IS_LAST_CHECKED_NODE_LEAF = lcn.isLeaf ? 'Y' : 'N';
            data.LAST_CHECKED_NODE_VALUE_PATH = lcn.getPath().map(function(n) {
                return n.id
            });
        }

        if (self.lastSelectedNode) {
            var lsn = self.lastSelectedNode;
            data.LAST_SELECTED_NODE_NAME = lsn.name;
            data.LAST_SELECTED_NODE_VALUE = lsn.id;
            data.LAST_SELECTED_LEVEL = lsn.level;
            data.IS_LAST_SELECTED_NODE_LEAF = lsn.isLeaf ? 'Y' : 'N';
            data.LAST_SELECTED_NODE_VALUE_PATH = lsn.getPath().map(function(n) {
                return n.id
            });
            var fdata = self.lastSelectedNode.data;
            for (var i in fdata) {
                data[i] = fdata[i];
            }
        }
        data.SELECTED_NODE_VALUES = (self.zTreeObj.getSelectedNodes() || [])
                                    .map(function(n) {
                                        return n.id
                                    });
        data.CHECKED_NODE_VALUES = (self.zTreeObj.getCheckedNodes() || [])
                                    .map(function(n) {
                                        return n.id
                                    });
        return data;
    },
    isReady: function() {
        var isReady = true;
        if (!isReady) {
            // Do sth to show user this widget is not ready.
        }
        return isReady;
    },
    affected: function(zContext) {
        this.__createTree(zContext);
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/